import { Table } from "react-bootstrap";

const cleaningReadinessData = [
  {
    metric: "Subjects with zero open queries",
    value: 13,
    context: "of 106",
  },
  {
    metric: "Form instances with zero open queries",
    value: 213,
    context: "of 424 in lock scope",
  },
  {
    metric: "Visits fully cleaned",
    value: 0,
    context: "of 10",
  },
  {
    metric: "Sites ready for lock",
    value: 0,
    context: "of 7",
  },
  {
    metric: "Open critical queries",
    value: 31,
    context: "blocking DBL",
  },
  {
    metric: "Open queries on frozen forms",
    value: 59,
    context: "requires unfreeze workflow",
  },
  {
    metric: "Open queries on locked forms",
    value: 34,
    context: "requires unlock + audit reason",
  },
  {
    metric: "Queries pending before DBL",
    value: 242,
    context: "total unresolved",
  },
  {
    metric: "Query backlog risk",
    value: "High",
    context: "based on unresolved volume",
  },
];

const CleaningReadinessMetricsTable = () => {
  return (
    <>
      <Table className="m-0 custom-table" hover striped>
        <thead className="position-sticky top-0 z-1">
          <tr>
            <th>READINESS METRIC</th>
            <th>VALUE</th>
            <th>CONTEXT</th>
          </tr>
        </thead>

        <tbody>
          {cleaningReadinessData.map((item, index) => (
            <tr key={index}>
              <td>{item.metric}</td>

              <td
                className={`fw-bold ${
                  item.value === "High" ? "text-danger" : "text-primary"
                }`}
              >
                {item.value}
              </td>

              <td className="text-muted">{item.context}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default CleaningReadinessMetricsTable;
